import { value as value_5, map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { asMoney, asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { Tab_Option, tab, Option, tabs } from "../../../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { empty as empty_1, ofArray, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { equalsWith, find, tryFind, sortBy, map as map_1 } from "../../../fable_modules/fable-library-js.4.19.0/Array.js";
import * as react from "react";
import { Model__HasUploadsInFlight, Model__CanErteileAuftrag, Msg_$reflection, Msg } from "./Types.fs.js";
import { defaultOf, equals as equals_2, int32ToString, compareArrays } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, array_type, lambda_type, unit_type, option_type, class_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Sendungen_Belegeingang__get_Value, Sendungen_SendungsOption, Sendungen_Filiale_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { DropdownProps$1, bfsDropdown } from "../Shared/Dropdown.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { errorMsg, spinner, orangeCheckbox, linkicon, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Page } from "../Tickets/Types.fs.js";
import { Helpers_nothing } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { asMoneySpan } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { Accept, UploadFileType_Pdf, UploadBox } from "../../../../Bfs.Web.Portale/UploadBox.fs.js";
import { parse, date as date_3, equals } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { left } from "../../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { select } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Select.fs.js";
import { fromParts, equals as equals_1 } from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";

export function renderDate(date) {
    return defaultArg(map(asString, date), "-");
}

export function filialenRow(selectedFilialeId, dispatch, filialen) {
    const selectedFilialeId_1 = defaultArg(selectedFilialeId, "00000000-0000-0000-0000-000000000000");
    return tabs(singleton(new Option(7, ["is-hidden-touch account-tabs main-menu with-width-constraint"])), [map_1((f_1) => tab(ofArray([new Tab_Option(1, ["submenu-item"]), new Tab_Option(0, [f_1.FilialeId === selectedFilialeId_1])]), singleton(react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(4, [f_1.FilialeId]));
        },
    }, f_1.Name))), sortBy((f) => [!f.IsZentrale, f.Name], filialen, {
        Compare: compareArrays,
    }))]);
}

export class FilialeMobileProps extends Record {
    constructor(SelectedFilialeId, Dispatch, Filialen) {
        super();
        this.SelectedFilialeId = SelectedFilialeId;
        this.Dispatch = Dispatch;
        this.Filialen = Filialen;
    }
}

export function FilialeMobileProps_$reflection() {
    return record_type("Sendungen.View.FilialeMobileProps", [], FilialeMobileProps, () => [["SelectedFilialeId", option_type(class_type("System.Guid"))], ["Dispatch", lambda_type(Msg_$reflection(), unit_type)], ["Filialen", array_type(Sendungen_Filiale_$reflection())]]);
}

export function filialenMobile(selectedFilialeId, dispatch, filialen) {
    const children = [bfsDropdown()(new DropdownProps$1(ofArray(sortBy((f) => [!f.IsZentrale, f.Name], filialen, {
        Compare: compareArrays,
    })), tryFind((filiale_1) => {
        if (selectedFilialeId != null) {
            return filiale_1.FilialeId === value_5(selectedFilialeId);
        }
        else {
            return false;
        }
    }, filialen), (_arg_1) => _arg_1.Name, (_arg) => _arg.FilialeId, (filiale) => {
        dispatch(new Msg(4, [filiale.FilialeId]));
    }))];
    return react.createElement("div", {
        className: "is-hidden-desktop mb-2",
    }, ...children);
}

export function ticketText(sendung) {
    return toText(printf("Sendung %d"))(sendung.SendungsNr);
}

export function actionHoverMenu(dispatch, navigateTo, sendung) {
    let children_2, children, children_18, children_16;
    const menuName = toText(printf("dropdown-%O"))(sendung.SendungId);
    const children_20 = [(children_2 = [(children = [icon("fas fa-ellipsis-v")], react.createElement("div", {
        "aria-haspopup": true,
        "aria-controls": menuName,
    }, ...children))], react.createElement("div", {
        className: "dropdown-trigger",
    }, ...children_2)), (children_18 = [(children_16 = toList(delay(() => {
        let props_4;
        return append(singleton_1((props_4 = [new HTMLAttr(65, ["dropdown-item"]), ["style", {
            fontWeight: "bold",
            textAlign: "center",
        }]], react.createElement("p", keyValueList(props_4, 1), `Sendung ${sendung.SendungsNr}`))), delay(() => append(singleton_1(react.createElement("hr", {
            className: "dropdown-divider",
        })), delay(() => {
            let children_6;
            return append(sendung.AllowUploads ? singleton_1((children_6 = [icon("fas fa-upload icon"), "Dokumente hochladen"], react.createElement("a", {
                className: "dropdown-item",
                onClick: (_arg) => {
                    dispatch(new Msg(5, [sendung]));
                },
            }, ...children_6))) : empty(), delay(() => {
                let children_8;
                return append(sendung.AllowDokumentenDepot ? singleton_1((children_8 = [icon("fas fa-archive icon"), "Dokumenten-Depot nutzen"], react.createElement("a", {
                    className: "dropdown-item",
                    onClick: (_arg_1) => {
                        dispatch(new Msg(12, [sendung]));
                    },
                }, ...children_8))) : empty(), delay(() => {
                    let children_10;
                    return append(sendung.AllowUploads ? singleton_1((children_10 = [icon("fas fa-file-times icon"), "Beleglose Sendung"], react.createElement("a", {
                        className: "dropdown-item",
                        onClick: (_arg_2) => {
                            dispatch(new Msg(14, [sendung]));
                        },
                    }, ...children_10))) : empty(), delay(() => {
                        let children_12;
                        return append(sendung.AllowFlexitarif ? singleton_1((children_12 = [icon("fas fa-shipping-fast"), "Flexitarif auswählen"], react.createElement("a", {
                            className: "dropdown-item",
                            onClick: (_arg_3) => {
                                dispatch(new Msg(21, [sendung]));
                            },
                        }, ...children_12))) : empty(), delay(() => {
                            let children_14;
                            return singleton_1((children_14 = [icon("fas fa-ticket icon"), "Ticket erstellen"], react.createElement("a", {
                                className: "dropdown-item",
                                onClick: (_arg_4) => {
                                    navigateTo(new Page(3, [ticketText(sendung), undefined]));
                                },
                            }, ...children_14)));
                        }));
                    }));
                }));
            }));
        }))));
    })), react.createElement("div", {
        className: "dropdown-content",
    }, ...children_16))], react.createElement("div", {
        className: "dropdown-menu",
        id: menuName,
        role: "menu",
    }, ...children_18))];
    return react.createElement("div", {
        className: "dropdown is-hoverable is-right",
    }, ...children_20);
}

export function iconsForSendung(sendung) {
    let props_8, children_8;
    let e;
    const matchValue = sendung.SendungsOption;
    if (matchValue == null) {
        e = Helpers_nothing;
    }
    else {
        switch (matchValue.tag) {
            case 1: {
                const props_2 = [new HTMLAttr(65, ["tooltip"]), ["data-tooltip", "Mischsendung"]];
                const children_2 = [linkicon("fas fa-print")];
                e = react.createElement("span", keyValueList(props_2, 1), ...children_2);
                break;
            }
            case 2: {
                const props_4 = [new HTMLAttr(65, ["tooltip"]), ["data-tooltip", "Dokumentendepot"]];
                const children_4 = [linkicon("fas fa-archive")];
                e = react.createElement("span", keyValueList(props_4, 1), ...children_4);
                break;
            }
            case 3: {
                const props_6 = [new HTMLAttr(65, ["tooltip"]), ["data-tooltip", "Sendung ohne Belege"]];
                const children_6 = [linkicon("fas fa-file-times")];
                e = react.createElement("span", keyValueList(props_6, 1), ...children_6);
                break;
            }
            default: {
                const props = [new HTMLAttr(65, ["tooltip"]), ["data-tooltip", "Ohne Originalbelege"]];
                const children = [linkicon("fas fa-print-slash")];
                e = react.createElement("span", keyValueList(props, 1), ...children);
            }
        }
    }
    if (sendung.TarifGewaehlt) {
        return [e, (props_8 = [new HTMLAttr(65, ["tooltip"]), ["data-tooltip", "Flexitarif"]], (children_8 = [linkicon("fas fa-shipping-fast")], react.createElement("span", keyValueList(props_8, 1), ...children_8)))];
    }
    else {
        return e;
    }
}

export function sendungenMobile(sendungen, model, dispatch, navigateTo) {
    const children_22 = [map_1((s) => {
        let children_8, children_4, children_6, children_18;
        const children_20 = [(children_8 = [(children_4 = toList(delay(() => append(singleton_1(toText(printf("Sendung %d "))(s.SendungsNr)), delay(() => {
            let children, arg_1;
            return append((s.Gesamtbetrag != null) ? singleton_1((children = [(arg_1 = asMoney(value_5(s.Gesamtbetrag)), toText(printf(" (%s)"))(arg_1))], react.createElement("span", {}, ...children))) : empty(), delay(() => {
                let children_2;
                return singleton_1((children_2 = [iconsForSendung(s)], react.createElement("span", {}, ...children_2)));
            }));
        })))), react.createElement("div", {
            className: "dta-file",
        }, ...children_4)), (children_6 = [actionHoverMenu(dispatch, navigateTo, s)], react.createElement("div", {
            className: "dta-date",
        }, ...children_6))], react.createElement("div", {}, ...children_8)), (children_18 = toList(delay(() => {
            let children_10;
            return append((s.Angekauft != null) ? singleton_1((children_10 = ["Davon angekauft: ", asMoney(value_5(s.Angekauft))], react.createElement("div", {}, ...children_10))) : empty(), delay(() => {
                let children_12;
                return append((s.Belegeingang != null) ? singleton_1((children_12 = ["Belegeingang: ", asString(value_5(s.Belegeingang))], react.createElement("div", {}, ...children_12))) : empty(), delay(() => {
                    let children_14;
                    return append((s.Belegpruefung != null) ? singleton_1((children_14 = ["Belegprüfung: ", asString(value_5(s.Belegpruefung))], react.createElement("div", {}, ...children_14))) : empty(), delay(() => {
                        let children_16;
                        return (s.ErwartetesZahldatum != null) ? singleton_1((children_16 = ["Erwartetes Zahldatum: ", asString(value_5(s.ErwartetesZahldatum))], react.createElement("div", {}, ...children_16))) : empty();
                    }));
                }));
            }));
        })), react.createElement("div", {
            className: "dta-status",
        }, ...children_18))];
        return react.createElement("div", {
            className: "data-item",
        }, ...children_20);
    }, sendungen)];
    return react.createElement("div", {
        className: "data-list is-hidden-desktop",
    }, ...children_22);
}

export function sendungZeile(dispatch, navigateTo, model, sendung) {
    let children_2, children_4, children_6, children_8, children_10, children_12, children_14, children_16;
    const children_18 = [(children_2 = [react.createElement("p", {}, `Sendung ${sendung.SendungsNr}`)], react.createElement("td", {}, ...children_2)), (children_4 = [iconsForSendung(sendung)], react.createElement("td", {
        className: "text-left",
    }, ...children_4)), (children_6 = [renderDate(sendung.Belegeingang)], react.createElement("td", {
        className: "text-right",
    }, ...children_6)), (children_8 = [renderDate(sendung.Belegpruefung)], react.createElement("td", {
        className: "text-right",
    }, ...children_8)), (children_10 = [renderDate(sendung.ErwartetesZahldatum)], react.createElement("td", {
        className: "text-right",
    }, ...children_10)), (children_12 = [defaultArg(map(asMoneySpan, sendung.Gesamtbetrag), "-")], react.createElement("td", {
        className: "text-right",
    }, ...children_12)), (children_14 = [defaultArg(map(asMoneySpan, sendung.Angekauft), "-")], react.createElement("td", {
        className: "text-right",
    }, ...children_14)), (children_16 = [actionHoverMenu(dispatch, navigateTo, sendung)], react.createElement("td", {
        className: "pull-right",
    }, ...children_16))];
    return react.createElement("tr", {}, ...children_18);
}

export function sendungenTabelle(sendungen, model, dispatch, navigateTo) {
    let children_18, children_16;
    const rows = map_1((sendung) => sendungZeile(dispatch, navigateTo, model, sendung), sendungen);
    const children_22 = [(children_18 = [(children_16 = [react.createElement("th", {}, "SendungsNr"), react.createElement("th", {
        className: "text-left",
    }, "Besonderheit"), react.createElement("th", {
        className: "text-right",
    }, "Belegeingang"), react.createElement("th", {
        className: "text-right",
    }, "Belegprüfung"), react.createElement("th", {
        className: "text-right",
    }, "Erwartetes Zahldatum"), react.createElement("th", {
        className: "text-right",
    }, "Gesamtbetrag"), react.createElement("th", {
        className: "text-right",
    }, "Davon angekauft"), react.createElement("th", {
        className: "text-right",
    })], react.createElement("tr", {}, ...children_16))], react.createElement("thead", {}, ...children_18)), react.createElement("tbody", {}, ...rows)];
    return react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch is-bfscolored",
    }, ...children_22);
}

export const emptyContent = (() => {
    let children_12, children_10, children_4, children_2, children_8;
    const children_14 = [(children_12 = [(children_10 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Keine Sendungen")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [react.createElement("p", {}, "Innerhalb des letzten halben Jahres liegen uns keine Sendungen vor.")], react.createElement("div", {
        className: "card-body",
    }, ...children_8))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_10))], react.createElement("div", {
        className: "column is-12",
    }, ...children_12))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_14);
})();

export function content(dispatch, navigateTo, sendungen, model) {
    let children_4, children_2, children;
    const children_6 = [(children_4 = [(children_2 = [(children = [sendungenTabelle(sendungen, model, dispatch, navigateTo), sendungenMobile(sendungen, model, dispatch, navigateTo)], react.createElement("div", {
        className: "card-body",
    }, ...children))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial is-relative",
    }, ...children_2))], react.createElement("div", {
        className: "column is-12",
    }, ...children_4))];
    return react.createElement("div", {
        className: "sendungen columns",
    }, ...children_6);
}

export function sendungenUploadBox(sendung, model, dispatch) {
    return UploadBox([new Accept(1, [singleton(UploadFileType_Pdf)]), (filelist) => {
        dispatch(new Msg(8, [[sendung.SendungId, filelist]]));
    }, (file) => {
        dispatch(new Msg(10, [file]));
    }, model.CurrentUploadList, model.CurrentUploadCount, undefined, (msg) => {
        dispatch(new Msg(31, [msg]));
    }]);
}

export function uploadModal(model, sendung, dispatch) {
    let children_32, children_10, children_24, children_22, children_30, props_26;
    const papierlosExplain = "Ich habe keine Original-Belege und möchte alle Unterlagen, die zu dieser Sendung gehören, hochladen.";
    const mischSendungExplain = "Manche Rechnungen erfordern Originalbelege. Diese habe ich bereits mit dem Sendungsbegleitzettel an die BFS verschickt. Ich möchte nur für einzelne Rechnungen Unterlagen hochladen.";
    const uploadsDone = Model__CanErteileAuftrag(model);
    let patternInput;
    const matchValue = model.SelectedSendungsOption;
    let matchResult;
    if (matchValue != null) {
        switch (matchValue.tag) {
            case 0: {
                matchResult = 0;
                break;
            }
            case 1: {
                matchResult = 1;
                break;
            }
            default:
                matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            patternInput = ["bfsbutton is-selected", "", papierlosExplain, uploadsDone];
            break;
        }
        case 1: {
            patternInput = ["", "bfsbutton is-selected", mischSendungExplain, uploadsDone];
            break;
        }
        default:
            throw new Error("bad model state");
    }
    const button1 = react.createElement("button", {
        className: `button ${patternInput[0]} is-small`,
        onClick: (_arg) => {
            dispatch(new Msg(7, [new Sendungen_SendungsOption(0, [])]));
        },
    }, "Ohne Originalbelege");
    const button2 = react.createElement("button", {
        className: `button ${patternInput[1]} is-small`,
        onClick: (_arg_1) => {
            dispatch(new Msg(7, [new Sendungen_SendungsOption(1, [])]));
        },
    }, "Mischsendung");
    const buttons = react.createElement("div", {
        className: "buttons has-addons",
    }, button1, button2);
    const children_34 = [react.createElement("div", {
        className: "modal-background",
    }), (children_32 = [(children_10 = [react.createElement("div", {
        className: "modal-card-title",
    }, `Dokumente für Sendung ${sendung.SendungsNr} hochladen`)], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_10)), (children_24 = [(children_22 = toList(delay(() => {
        let children_20, children_16, children_18;
        return singleton_1((children_20 = [(children_16 = [react.createElement("h5", {
            className: "title is-5",
        }, "Sendungsoption"), buttons, react.createElement("p", {}, patternInput[2])], react.createElement("div", {
            className: "column is-half",
        }, ...children_16)), (children_18 = [sendungenUploadBox(sendung, model, dispatch)], react.createElement("div", {
            className: "column is-half",
        }, ...children_18))], react.createElement("div", {
            className: "columns",
        }, ...children_20)));
    })), react.createElement("div", {
        className: "info-Block",
    }, ...children_22))], react.createElement("section", {
        className: "modal-card-body overflow-initial",
    }, ...children_24)), (children_30 = [(props_26 = toList(delay(() => append((model.Sending ? true : Model__HasUploadsInFlight(model)) ? singleton_1(new HTMLAttr(65, ["bfsbutton is-loading"])) : singleton_1(new HTMLAttr(65, ["bfsbutton"])), delay(() => append(singleton_1(new HTMLAttr(79, [!patternInput[3]])), delay(() => singleton_1(new DOMAttr(40, [(_arg_2) => {
        dispatch(new Msg(16, []));
    }])))))))), react.createElement("button", keyValueList(props_26, 1), "Weiter")), react.createElement("button", {
        className: "button is-bfscolored",
        onClick: (_arg_3) => {
            dispatch(new Msg(6, []));
        },
    }, "Abbrechen")], react.createElement("footer", {
        className: "modal-card-foot",
    }, ...children_30))], react.createElement("div", {
        className: "modal-content overflow-initial",
    }, ...children_32))];
    return react.createElement("div", {
        className: "modal is-active datenuebergabe",
    }, ...children_34);
}

export function calcEntgelt(flexitarif, flexitarifAuswahl) {
    return find((t) => equals(date_3(t.Auszahlungstag), date_3(flexitarifAuswahl.AusfuehrungZahlung)), flexitarif.AuszahlungstageMitEntgelt).Entgelt;
}

export function getBelegeingangHeader(_arg) {
    if (_arg.tag === 1) {
        return "Erwarteter Belegeingang";
    }
    else {
        return "Belegeingang";
    }
}

export function flexitarifTableMobile(flexitarif, flexitarifAuswahl) {
    let children_38, children_6, children_4, children_12, children_10, children_18, children_16, children_24, children_30, children_28, children_36, children_34;
    const entgelt = calcEntgelt(flexitarif, flexitarifAuswahl);
    const belegeingangHeader = getBelegeingangHeader(flexitarif.Belegeingang);
    const children_40 = [react.createElement("thead", {}), (children_38 = [(children_6 = [react.createElement("td", {}, "Sendung Nr.:"), (children_4 = [int32ToString(flexitarif.SendungsNr)], react.createElement("td", {
        className: "text-right",
    }, ...children_4))], react.createElement("tr", {}, ...children_6)), (children_12 = [react.createElement("td", {}, `${belegeingangHeader}:`), (children_10 = [asString(Sendungen_Belegeingang__get_Value(flexitarif.Belegeingang))], react.createElement("td", {
        className: "text-right",
    }, ...children_10))], react.createElement("tr", {}, ...children_12)), (children_18 = [react.createElement("td", {}, "Forderungsvolumen:"), (children_16 = [asMoneySpan(flexitarif.ForderungsVolumen)], react.createElement("td", {
        className: "text-right",
    }, ...children_16))], react.createElement("tr", {}, ...children_18)), (children_24 = [react.createElement("td", {}, "Vereinbartes Zahlungsziel:"), react.createElement("td", {
        className: "text-right",
    }, `${flexitarif.VereinbartesZahlungsziel} Tage`)], react.createElement("tr", {}, ...children_24)), (children_30 = [react.createElement("td", {}, "Entgelt:"), (children_28 = [asMoneySpan(entgelt)], react.createElement("td", {
        className: "text-right",
    }, ...children_28))], react.createElement("tr", {}, ...children_30)), (children_36 = [react.createElement("td", {}, "Kalkulierte Zahlung:"), (children_34 = [asString(flexitarif.KalkuliertesZahlungsdatum)], react.createElement("td", {
        className: "text-right",
    }, ...children_34))], react.createElement("tr", {}, ...children_36))], react.createElement("tbody", {}, ...children_38))];
    return react.createElement("table", {
        className: "is-hidden-desktop table table-striped responsive-table",
    }, ...children_40);
}

export function flexitarifTable(flexitarif, flexitarifAuswahl) {
    let children_32, children_10, children_4, children_8, children_20, children_14, children_30, children_24, children_28;
    const entgelt = calcEntgelt(flexitarif, flexitarifAuswahl);
    const belegeingangHeader = getBelegeingangHeader(flexitarif.Belegeingang);
    const children_34 = [react.createElement("thead", {}), (children_32 = [(children_10 = [react.createElement("td", {}, "Sendung Nr.:"), (children_4 = [int32ToString(flexitarif.SendungsNr)], react.createElement("td", {
        className: "text-right",
    }, ...children_4)), react.createElement("td", {}, `${belegeingangHeader}:`), (children_8 = [asString(Sendungen_Belegeingang__get_Value(flexitarif.Belegeingang))], react.createElement("td", {
        className: "text-right",
    }, ...children_8))], react.createElement("tr", {}, ...children_10)), (children_20 = [react.createElement("td", {}, "Forderungsvolumen:"), (children_14 = [asMoneySpan(flexitarif.ForderungsVolumen)], react.createElement("td", {
        className: "text-right",
    }, ...children_14)), react.createElement("td", {}, "Vereinbartes Zahlungsziel:"), react.createElement("td", {
        className: "text-right",
    }, `${flexitarif.VereinbartesZahlungsziel} Tage`)], react.createElement("tr", {}, ...children_20)), (children_30 = [react.createElement("td", {}, "Entgelt:"), (children_24 = [asMoneySpan(entgelt)], react.createElement("td", {
        className: "text-right",
    }, ...children_24)), react.createElement("td", {}, "Kalkulierte Zahlung:"), (children_28 = [asString(flexitarif.KalkuliertesZahlungsdatum)], react.createElement("td", {
        className: "text-right",
    }, ...children_28))], react.createElement("tr", {}, ...children_30))], react.createElement("tbody", {}, ...children_32))];
    return react.createElement("table", {
        className: "is-hidden-touch table table-striped responsive-table",
    }, ...children_34);
}

export function orangeCheckboxWithElem(ischecked, elem, onclick) {
    let children;
    return left(empty_1(), ofArray([elem, (children = [orangeCheckbox(ischecked, onclick)], react.createElement("div", {
        className: "flexitarif orangeCheckboxWithText",
    }, ...children))]));
}

export function dropDown(dispatch, selectedAuszahlungstag, entgelte) {
    let children_6;
    const options = ofArray(map_1((e) => {
        const props = [new HTMLAttr(161, [e.Auszahlungstag]), new HTMLAttr(143, [equals(date_3(e.Auszahlungstag), date_3(selectedAuszahlungstag))])];
        const children = [asString(e.Auszahlungstag)];
        return react.createElement("option", keyValueList(props, 1), ...children);
    }, entgelte));
    const children_8 = [react.createElement("div", {
        className: "label",
    }, "Ausführungszeitpunkt der Zahlung"), (children_6 = [select(empty_1(), singleton(react.createElement("select", {
        className: "select input",
        onChange: (e_1) => {
            dispatch(new Msg(24, [parse(e_1.target.value)]));
        },
    }, ...options)))], react.createElement("div", {
        className: "control",
    }, ...children_6))];
    return react.createElement("div", {
        className: "field",
    }, ...children_8);
}

export function flexitarifModal(model, flexitarif, flexitarifAuswahl, dispatch) {
    let children_2, children_22, children_10, children_8, children_14, children_12, children_20, props_24;
    const agbCheckbox = orangeCheckboxWithElem(model.AgbAkzeptiert, (children_2 = ["Ich akzeptiere die ", react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(27, [flexitarif.Agb]));
        },
    }, "Zusatzvereinbarung")], react.createElement("p", {}, ...children_2)), (_arg_1) => {
        dispatch(new Msg(25, []));
    });
    let modalitaeten;
    const entgelt = `Das zusätzliche Entgelt beträgt ${asMoney(flexitarif.EntgeltFuerVorziehung)} je 1.000,00 € und Kalendertag.`;
    const einbehalt = ` Es wird ein Sicherheitsguthaben von ${flexitarif.SicherheitsguthabenProzent} % der Forderungssumme einbehalten: ${asMoney(flexitarif.SicherheitsguthabenBetrag)}`;
    modalitaeten = (!equals_1(flexitarif.SicherheitsguthabenProzent, fromParts(0, 0, 0, false, 1)) ? (entgelt + einbehalt) : entgelt);
    const zahlungDropDown = dropDown(dispatch, flexitarifAuswahl.AusfuehrungZahlung, flexitarif.AuszahlungstageMitEntgelt);
    const flexitarifControls = [react.createElement("br", {}), zahlungDropDown, react.createElement("br", {}), agbCheckbox, react.createElement("br", {}), react.createElement("p", {
        className: "modalitaeten",
    }, modalitaeten)];
    const children_24 = [react.createElement("div", {
        className: "modal-background",
    }), (children_22 = [(children_10 = [(children_8 = ["Flexitarif für ", react.createElement("br", {
        className: "is-hidden-tablet",
    }), `Sendung ${flexitarif.SendungsNr} wählen`], react.createElement("div", {
        className: "modal-card-title",
    }, ...children_8))], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_10)), (children_14 = [(children_12 = toList(delay(() => append(singleton_1(flexitarifTable(flexitarif, flexitarifAuswahl)), delay(() => append(singleton_1(flexitarifTableMobile(flexitarif, flexitarifAuswahl)), delay(() => singleton_1(flexitarifControls))))))), react.createElement("div", {
        className: "info-Block",
    }, ...children_12))], react.createElement("section", {
        className: "modal-card-body overflow-auto",
    }, ...children_14)), (children_20 = [(props_24 = [new HTMLAttr(65, ["bfsbutton is-bfscolored"]), new HTMLAttr(79, [!model.AgbAkzeptiert]), new DOMAttr(40, [(_arg_2) => {
        dispatch(new Msg(28, []));
    }])], react.createElement("button", keyValueList(props_24, 1), "Kostenpflichtig buchen")), react.createElement("button", {
        className: "button is-bfscolored",
        onClick: (_arg_3) => {
            dispatch(new Msg(23, []));
        },
    }, "Abbrechen")], react.createElement("footer", {
        className: "modal-card-foot",
    }, ...children_20))], react.createElement("div", {
        className: "modal-content overflow-auto",
    }, ...children_22))];
    return react.createElement("div", {
        className: "modal is-active flexitarif",
    }, ...children_24);
}

export function infoBox(dispatch, navigateTo) {
    let children_32, children_30, children_8, children_6, children_4, s_1, children_18, children_16, children_14, s_3, children_28, children_26, children_24, s_5;
    const children_36 = [(children_32 = [(children_30 = [(children_8 = [react.createElement("i", {
        className: "fas fa-archive fa-2x",
    }), (children_6 = [react.createElement("p", {
        className: "header",
    }, "Dokumenten-Depot"), (children_4 = [(s_1 = "Die Belege für Ihre Sendung befinden sich in unserem Dokumenten-Depot? Dann geben Sie uns einfach Bescheid, damit wir die Belege der Sendung zu sortieren können.", s_1)], react.createElement("p", {}, ...children_4))], react.createElement("div", {}, ...children_6))], react.createElement("div", {
        className: "column is-4",
    }, ...children_8)), (children_18 = [react.createElement("i", {
        className: "fas fa-upload fa-2x",
    }), (children_16 = [react.createElement("p", {
        className: "header",
    }, "Dokumenten-Upload"), (children_14 = [(s_3 = "Für Ihre Sendung möchten Sie Belege hochladen und oder Belege hinzufügen? Dann laden Sie die Belege direkt hier hoch.", s_3)], react.createElement("p", {}, ...children_14))], react.createElement("div", {}, ...children_16))], react.createElement("div", {
        className: "column is-4",
    }, ...children_18)), (children_28 = [react.createElement("i", {
        className: "fas fa-shipping-fast fa-2x",
    }), (children_26 = [react.createElement("p", {
        className: "header",
    }, "Flexitarif nacherfassen"), (children_24 = [(s_5 = "Ihre Auszahlung möchten Sie noch schnell vorziehen? Bis zum Belegeingang Ihrer Sendung können Sie Ihren Zahlwunsch festlegen.", s_5)], react.createElement("p", {}, ...children_24))], react.createElement("div", {}, ...children_26))], react.createElement("div", {
        className: "column is-4",
    }, ...children_28))], react.createElement("div", {
        className: "columns",
    }, ...children_30))], react.createElement("div", {
        className: "container",
    }, ...children_32)), react.createElement("button", {
        onClick: (_arg) => {
            dispatch(new Msg(30, []));
        },
        className: "bfsdelete narrow",
        title: "schließen",
    })];
    return react.createElement("div", {
        className: "sendungen box",
    }, ...children_36);
}

export function view(model, dispatch, navigateTo) {
    return Array.from(delay(() => append(model.ShowInfoBox ? singleton_1(infoBox(dispatch, navigateTo)) : empty(), delay(() => {
        let matchValue, testExpr, testExpr_1;
        return append((matchValue = model.Filialen, (matchValue.tag === 1) ? singleton_1(spinner) : ((matchValue.tag === 2) ? singleton_1(errorMsg(matchValue.fields[0])) : ((matchValue.tag === 3) ? (((testExpr = matchValue.fields[0], !equalsWith(equals_2, testExpr, defaultOf()) && (testExpr.length === 0))) ? (empty()) : (((testExpr_1 = matchValue.fields[0], !equalsWith(equals_2, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) ? (empty()) : append(singleton_1(filialenRow(model.SelectedFilialeId, dispatch, matchValue.fields[0])), delay(() => singleton_1(filialenMobile(model.SelectedFilialeId, dispatch, matchValue.fields[0])))))) : singleton_1(spinner)))), delay(() => {
            let matchValue_1, testExpr_2;
            return append((matchValue_1 = model.Sendungen, (matchValue_1.tag === 3) ? (((testExpr_2 = matchValue_1.fields[0], !equalsWith(equals_2, testExpr_2, defaultOf()) && (testExpr_2.length === 0))) ? singleton_1(emptyContent) : singleton_1(content(dispatch, (arg) => {
                navigateTo(arg);
            }, matchValue_1.fields[0], model))) : ((matchValue_1.tag === 1) ? singleton_1(spinner) : ((matchValue_1.tag === 2) ? singleton_1(errorMsg(matchValue_1.fields[0])) : singleton_1(emptyContent)))), delay(() => {
                let matchValue_2, matchValue_3, sendung;
                return append((matchValue_2 = model.SelectedSendung, (matchValue_3 = model.SelectedSendungsOption, (matchValue_2 != null) ? ((matchValue_3 != null) ? ((matchValue_3.tag === 0) ? ((sendung = matchValue_2, singleton_1(uploadModal(model, sendung, dispatch)))) : ((matchValue_3.tag === 1) ? ((sendung = matchValue_2, singleton_1(uploadModal(model, sendung, dispatch)))) : (empty()))) : ((sendung = matchValue_2, singleton_1(uploadModal(model, sendung, dispatch))))) : (empty()))), delay(() => {
                    const matchValue_5 = model.Flexitarif;
                    const matchValue_6 = model.FlexitarifAuswahl;
                    let matchResult, flexitarif, flexitarifAuswahl;
                    if (matchValue_5 != null) {
                        if (matchValue_6 != null) {
                            matchResult = 0;
                            flexitarif = matchValue_5;
                            flexitarifAuswahl = matchValue_6;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton_1(flexitarifModal(model, flexitarif, flexitarifAuswahl, dispatch));
                        default: {
                            return empty();
                        }
                    }
                }));
            }));
        }));
    }))));
}

//# sourceMappingURL=View.fs.js.map
